// extracted by mini-css-extract-plugin
export default {"item":"BurnItem_item__4EGUF"};